import React from 'react'

import './button.scss'

const Button = ({title, value = '', onClick, style = {}, className = '', variant = ''}) => {
    return <div id={`button-${variant}`} className={className} style={style} onClick={() => onClick(value)}>
        {title}
    </div>
}

export default Button
